<div class="dialog-container">
    <h1 mat-dialog-title class="dialog-title">{{title}}</h1>
    
    <div mat-dialog-content class="dialog-content">{{message}}</div>
    
    <div mat-dialog-actions class="dialog-actions">
      <button mat-button class="rejectButton"  (click)="onDismiss()">No</button>
      <button mat-raised-button color="primary" class="confirmButton" (click)="onConfirm()">Yes</button>
    </div>
  </div>
